import { InvoiceDeliveryMethod, LeaseAgreementInformationRowContentKind } from '../../invoice/model/const/enum';
import { MailDeliverySpeed } from '../../common/model/const/enum';

export enum EmailProviderKind {
  Platform = 0,
  SendGrid = 1,
}

export interface EmailProviderTestRequest {
  recipientAddress: string;
  provider: EmailProviderKind;
  sendGridApiKey: string;
  senderAddress: string;
  senderName: string;
}

export class ProfileSettings {
  constructor() {}
  autoAttest: boolean;
  displayOrganizationNo: boolean;
  includeQRCodeInEmailBody: boolean;
  inactivityTimeoutMinutes: number;
  locationAccessControlActive: boolean;
  rentInvoiceCaption: string;
  enableESignature: boolean;
  enableInvoicing: boolean;
  enableEInvoiceB2C: boolean;
  enableUserFeatures: boolean;
  invoiceDeliveryMethod: InvoiceDeliveryMethod;
  leaseAgreementInformationRowContent: LeaseAgreementInformationRowContentKind;
  nextInvoiceNo: number;
  removeTenants: number;
  removeMails: number;
  mailDeliverySpeed: MailDeliverySpeed;
  emailSender: string;
  useFastighetsagarnaDokument: boolean;
  fastighetsagarnaApiKey: string;
  useAvyApi: boolean;
  avyApiClientId: string;
  avyApiClientSecret: string;
  automaticDefermentUpToAmount: number;
  moveMissingAndAdditionalPaymentDecimalsToRounding: boolean;
  sendZeroInvoice: boolean;
  useDhMarket: boolean;
  dhMarketPassword: string;
  dhMarketUserName: string;
  dhMarketBackOfficeDomain: string;
  useHomeQ: boolean;
  homeQPassword: string;
  homeQUsername: string;
  useBoplatsSverige: boolean;
  boplatsSverigeCustomerGuid: string;
  boplatsSverigeDescriptionUrlPathTemplate: string;
  allowDuplicateSwedishSSN: boolean;
  senderOfMessages: string;
  defaultResponseTimeEsigningCase: number;
  useMortgage: boolean;
  useBrf: boolean;
  brfLeaseAgreementDateType: number;
  brfControlDataProviderName: string;
  brfControlDataProviderPhone: string;
  brfControlDataProviderEmail: string;
  brfControlDataProviderOrganizationNumber: string;
  useAvy: boolean;
  useKivra: boolean;
  useInvoiceRowGroup: boolean;
  useRopoOne: boolean;
  ropoOneCid: string;
  ropoOneApiKey: string;
  useProtectedIdentity: boolean;
  protectedIdentityBetaEnabled: boolean;
  hasProtectedIdentityApiKey: boolean;
  useWebhook: boolean;
  webhookUrl: string;
  useOwnSendGrid: boolean;
  sendGridApiKey: string;
  hasSendGridApiKey: boolean;
  emailProviderSenderAddress: string;
  emailProviderSenderName: string;
  sendGridEventWebhookUrl: string;
}
